import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ManageTestEvent from 'assets/svgs/manageTestEvent.svg';

import './TcEventChecklist.scss';

const TcEventChecklist = ({ event, eventTasks, completedEventTasks }) => {
  const { t } = useTranslation();
  return (
    <section className="event-task-section">
      <div className="mb-4">
        <div>
          <span className="fw-bold">{t('testCenter.eventDashboard.preTestLabel')}: </span>
          <span>{t('testCenter.eventDashboard.tasksOfCompleted', { completed: completedEventTasks.pre.length, total: eventTasks.pre.length })} </span>
        </div>
        <div>
          <span className="fw-bold">{t('testCenter.eventDashboard.postTestLabel')}: </span>
          <span>{t('testCenter.eventDashboard.tasksOfCompleted', { completed: completedEventTasks.post.length, total: eventTasks.post.length })} </span>
        </div>
      </div>
      <Link
        to={`/test-event/${event.id}/event-checklist`}
        href={`/test-event/${event.id}/event-checklist`}
        className="fw-bold mt-2 btn-link svg-right"
      >
        <ManageTestEvent/>{t('testCenter.eventDashboard.manageCheckList')}
      </Link>
    </section>
  );
};

export default TcEventChecklist;

TcEventChecklist.propTypes = {
  event: PropTypes.shape({}).isRequired,
  eventTasks: PropTypes.shape({}),
  completedEventTasks: PropTypes.shape({}),
};
